import React, { useState, useEffect } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faHouseChimney , faEarthAsia , faArrowRightFromBracket} from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import homeIcone from "../../../assets/Images/Home.png";
import speedtest from "../../../assets/Images/speedtest.png";
import inasIcone from "../../../assets/Images/inas.png";
import adminPage from "../../../assets/Images/pie-chart.png";
import logoutIcon from "../../../assets/Images/logout.png";
import { fetchFirebaseToken } from "../../../firebase.js";
import * as api from '../../../api_function';


const Sidebar = () => {
    const user_name = sessionStorage.getItem("userName");
    const navigate = useNavigate()
    const userEmail = sessionStorage.getItem('userEmail');
    const [getAdminUser, setAdminUser] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const getAllUsers = await api.getAllUsers();
                // console.log("getAllUsers", getAllUsers.data);

                if (getAllUsers?.meta?.Status) {
                    const adminUsers = getAllUsers.data.filter((data) => (data.role)?.toLowerCase() === 'admin' && data.email === userEmail)
                    // console.log(adminUsers);
                    setAdminUser(adminUsers?.length > 0)
                }
            } catch (error) {
                console.error("Error:", error);
            }
        }
        fetchData();
    }, [])

    const redirectDashboardPage = () => {
        navigate('/dashboradrc');
    }

    const redirectCampaginDetailsPage = () => {
        navigate('/whatsappData');
    }

    const redirectUmpSrDetailsPage = () => {
        navigate('/umpSrDetails');
    }


    const handleLogout = async () => {
        navigate("/");
        sessionStorage.clear();
        localStorage.clear();
        Cookies.remove('userName');
        Cookies.remove('password');
        Cookies.remove('userEmail');
        Cookies.remove('gmcToken');

        const newToken = await fetchFirebaseToken();
        if (!newToken) {
            console.warn("Failed to reinitialize Firebase token after logout");
        }
    }


    return (
        <>
            <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                {/* <div className="offcanvas offcanvas-start " tabindex="-1" id="offcanvas" data-bs-keyboard="false" data-bs-backdrop="false"> */}

                <div className="offcanvas-header text-light Header-style">
                    <h5 className="offcanvas-title" id="offcanvas" style={{ textWrap: "nowrap" }}>Hi , {user_name}</h5>

                    {/* <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button> */}
                </div>
                <div className="offcanvas-body p-0 ">
                    <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-start" id="menu">
                        <li className=" menu-item">
                            <span className="nav-link nav-link-ctm text-truncate text-dark" data-bs-dismiss="offcanvas" aria-label="Close" style={{ cursor: 'pointer' }} onClick={redirectDashboardPage}>
                                <img src={homeIcone} alt="icon" width="20" className='dashboard-icon'></img>
                                <span className="m-4">Home</span>
                            </span>
                        </li>

                         <li className=" menu-item">
                            <span className="nav-link nav-link-ctm text-truncate text-dark" data-bs-dismiss="offcanvas" aria-label="Close" style={{ cursor: 'pointer' }} onClick={redirectCampaginDetailsPage}>
                                <img src={homeIcone} alt="icon" width="20" className='dashboard-icon'></img>
                                <span className="m-4">Campaign Details</span>
                            </span>
                        </li>

                        <li className=" menu-item">
                            <span className="nav-link nav-link-ctm text-truncate text-dark" data-bs-dismiss="offcanvas" aria-label="Close" style={{ cursor: 'pointer' }} onClick={redirectUmpSrDetailsPage}>
                                <img src={homeIcone} alt="icon" width="20" className='dashboard-icon'></img>
                                <span className="m-4">Ump SR Details</span>
                            </span>
                        </li>

                        <li className="  menu-item">
                            <a href='http://spectraspeed.speedtestcustom.com' target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: 'black' }}>
                                <span className="nav-link nav-link-ctm text-truncate text-dark" style={{ cursor: 'pointer' }}>
                                    {/* <i className="fa-solid fa-earth-asia"></i> */}
                                    {/* <FontAwesomeIcon icon={faEarthAsia} /> */}
                                    <img src={speedtest} alt="icon" width="20" className='dashboard-icon'></img>
                                    <span className="m-3">Speed Test</span>
                                </span></a>
                        </li>
                        <li className=" menu-item">
                            <span className="nav-link nav-link-ctm text-truncate text-dark" style={{ cursor: 'pointer' }} onClick={handleLogout}>
                                {/* <i className="fa-solid fa-arrow-right-from-bracket"></i> */}
                                {/* <FontAwesomeIcon icon={faArrowRightFromBracket} /> */}
                                <img src={logoutIcon} alt="icon" width="20" className='dashboard-icon'></img>
                                <span className="m-3">Logout</span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Sidebar;
